import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import useJwt from "@/auth/jwt/useJwt";

export default {
  data() {
    return {
      countRq: 0,
    };
  },
  computed: {
    locations() {
      return [...this.useLocations, ...this.allLocationsPublic];
    },
    allLocationsPublic() {
      return this.$store.state.masterData.locations.filter((item) =>
        [1, 2, 3, 5].includes(item.location_type_id)
      );
    },
  },

  methods: {
    async loadCompany() {
      this.$loading.show();
      await this.$store.dispatch("masterData/fetchCompany");
      this.$loading.hide();
    },

    async loadLocations() {
      this.$loading.show();
      await this.$store.dispatch("masterData/fetchLocations");
      this.$loading.hide();
    },

    async loadShippingType() {
      this.$loading.show();
      await this.$store.commit("masterData/SET_SHIPPING_TYPE", []);
      await this.$store.dispatch("masterData/fetchShippingLine");
      this.$loading.hide();
    },
    pad(d) {
      return d < 10 ? "0" + d.toString() : d.toString();
    },
    isBlank(value) {
      const isFalsy = (value) => !value;
      const isWhitespaceString = (value) =>
        typeof value === "string" && /^\s*$/.test(value);
      const isEmptyCollection = (value) =>
        (Array.isArray(value) || value === Object(value)) &&
        !Object.keys(value).length;

      if (isFalsy(value)) return true;
      if (isWhitespaceString(value)) return true;
      if (isEmptyCollection(value)) return true;

      return false;
    },
    getUserLocation(n) {
      useJwt
        .get("getLocationsByUserId", {
          params: { page: 1, pageSize: 2000, userId: n },
        })
        .then((response) => {
          this.useLocations = response.data.result.map((e) => {
            const result = {};
            result.text =
              e.abbreviations + " - " + e.detail_address || e.location;
            result.id = e.location_id;
            result.name = e.location;
            result.abbreviations = e.abbreviations;

            result.address = e.detail_address || e.location;

            return result;
          });
        })
        .finally(() => {
          this.$loading.hide();
          this.countRq++;
        });
    },
    async onSubmit() {
      var validate = await this.$refs.requestSubmit
        .validate()
        .then((success) => {
          return success;
        });
      if (!validate) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: this.$i18n.t("notifyFormError"),
            icon: "AlertTriangleIcon",
            variant: "warning",
          },
        });
        return;
      }
      this.$loading.show();

      useJwt
        .put("wr1?objectType=AcceptQuotation", {
          id: this.quotationInfo.id,
          quotationInfo: this.quotationInfo,
        })
        .then((response) => {
          var vm = this;

          this.$swal({
            icon: "success",
            title: "Shipment has been created successfully",
            text: "Click here to view booking details!",
          }).then(function () {
            vm.$router.push({ name: "user-my-booking" });
          });
        })
        .catch((error) => {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: "Accept Quotation error!",
              icon: "AlertTriangleIcon",
              variant: "danger",
            },
          });
        })
        .finally(() => this.$loading.hide());
    },
  },
};
